<template>
    <div class="comparator-header d-flex">
        <div class="px-3 py-4 mx-auto w-100 d-flex justify-content-between align-items-center">
            <router-link :to="{ name: 'comparateur-index' }">
                <img alt="Logo" class="h-40px logo" src="../../../assets/logo.png"/>
            </router-link>
            <div class="header-actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import {Component, Vue} from 'vue-property-decorator';

    @Component({})
    export default class ComparatorHeader extends Vue {
    }
</script>
<style scoped>

</style>
